import gsap from 'gsap'
import { BB } from '@utils/utils'

import BaseComponent from './_BaseComponent'

const offsetX = 10
const offsetY = 5
const offsetA = 6

const initialAngles = [3, -6]

/* Floating Ribbons
---------------------------------------------------------------------------------------------------- */

export default class FloatingRibbons extends BaseComponent {

    constructor($el, namespace) {
        super('FloatingRibbons', $el, namespace)

        this.getSizes()

        this.on()
    }


    bindHandlers() {
        this.mouseLeaveHandler = e => this.onMouseLeave(e)
        this.mouseMoveHandler = e => this.onMouseMove(e)
        this.resizeHandler = () => this.onResize()
    }


    bindEvents() {
        this.addListeners(
            [this.$el, 'mouseleave', this.mouseLeaveHandler],
            [this.$el, 'mousemove', this.mouseMoveHandler],
            [document, 'layoutChange', this.resizeHandler],
        )
    }


    onMouseLeave(e) {
        this.resetCardPosition()
    }


    onMouseMove(e) {
        const { pageX, pageY } = e

        const transX = (pageX / this.ctnBounds.width) * 2 - 1
        const transY = -1 + ((pageY - this.ctnBounds.top) / (this.ctnBounds.height)) * 2

        gsap.to(this.$refs.card, {
            xPercent: transX * offsetX,
            yPercent: transY * offsetY,
            rotate: transX * offsetA,
            force3D: true,

            ease: 'power3.out',
            duration: 0.7,
            stagger: 0.1,
        })
    }


    onResize() {
        this.getSizes()
    }



    /* Actions
    --------------------------------------------------------- */


    resetCardPosition() {
        gsap.to(this.$refs.card, {
            xPercent: 0,
            yPercent: 0,
            rotate: i => initialAngles[i],
            force3D: true,

            ease: 'power3.out',
            duration: 0.8,
            overwrite: true,
            stagger: 0.05,
        })
    }

    /* Values
    --------------------------------------------------------- */

    getSizes() {
        const { top, width, height } = BB(this.$el[0])

        this.ctnBounds = {
            width,
            height,
            top: top + window.scrollY,
        }
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */
